import type { SxProps, Theme } from '@mui/material/styles';

export const sortSectionLabelSx: SxProps<Theme> = {
  display: 'block',
  padding: '0.5rem 0.75rem 0.25rem',
  fontSize: '0.6875rem',
  fontWeight: 600,
  letterSpacing: '0.03em',
  textTransform: 'uppercase',
  color: 'text.secondary',
};

export const sortLevelRowSx: SxProps<Theme> = {
  display: 'flex',
  alignItems: 'center',
  gap: '0.375rem',
  padding: '0.25rem 0.5rem 0.25rem 0.75rem',
};

export const sortLevelBadgeSx: SxProps<Theme> = {
  flexShrink: 0,
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  minWidth: '1.125rem',
  height: '1.125rem',
  padding: '0 0.25rem',
  borderRadius: '0.5625rem',
  backgroundColor: 'accent.main',
  color: 'common.white',
  fontSize: '0.6875rem',
  fontWeight: 600,
  lineHeight: 1,
};

export const sortLevelLabelSx: SxProps<Theme> = {
  flex: 1,
  minWidth: 0,
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
  fontSize: '0.8125rem',
};

export const sortLevelIconButtonSx: SxProps<Theme> = {
  padding: '0.125rem',
  '& .MuiSvgIcon-root': { fontSize: '0.9375rem' },
};

export const sortDirectionIconSx: SxProps<Theme> = {
  fontSize: '0.9375rem',
  color: 'accent.main',
};
